/**
 * the url prefix for the api gateway that attaches logged in users jwt to api requests
 *
 * We need two different api gateways because customer jwt cannot access
 * ref data endpoints
 */
export const SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX = "/api/gw/sp-customer";

/**
 * the url prefix for the api gateway that uses the service token to make api calls
 *
 * We need two different api gateways because customer jwt cannot access
 * ref data endpoints
 * @todo get ruby api changed so user access token has access to all api endpoints they should have access to
 *
 */
export const SIMPLE_PAYMENTS_SERVICE_GW_PREFIX = "/api/gw/sp-service";

/**
 * Public endpoints that don't require authentication for the sp-service gateway
 */
export const SIMPLE_PAYMENTS_SERVICE_PUBLIC_ENDPOINTS = [
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers`,
  },
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/sign_up_status`,
  },
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/reset_password`,
  },
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/verify_registration_id`,
  },
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/update_password`,
  },
] as const;

/**
 * Endpoints that require authentication for the sp-service gateway
 */
export const SIMPLE_PAYMENTS_SERVICE_AUTHENTICATED_ENDPOINTS = [
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/payout_methods`,
  },
] as const;

/**
 * Authenticated endpoints for the sp-customer gateway.
 * These endpoints use the user's JWT token and require a valid session.
 * Patterns with :param are matched as dynamic segments.
 */
export const SIMPLE_PAYMENTS_CUSTOMER_AUTHENTICATED_ENDPOINTS = [
  // Transactions
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/transactions`,
  },
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/transactions/:id/confirm`,
  },
  {
    method: "DELETE",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/transactions/:id`,
  },
  // Quotes
  {
    method: "POST",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/quotes`,
  },
  // Customers
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/customers/:id`,
  },
  {
    method: "PATCH",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/customers/:id`,
  },
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/customers/:id/limits`,
  },
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/customers/:id/documents`,
  },
  // Beneficiaries
  {
    method: "GET",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/beneficiaries`,
  },
  {
    method: "PATCH",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/beneficiaries/:id`,
  },
  {
    method: "DELETE",
    url: `${SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX}/api/v1/simple_payments/beneficiaries/:id`,
  },
] as const;
